import { ClientSessionState } from '@frame/lib/api/client-session/types'

export const routes = {
  root: '/',
  statedInformation: '/stated-information',
  companySearch: '/company-search',
  complete: '/complete',
  credentials: '/credentials',
  employmentSummary: '/employment-summary',
  selectIncomeType: '/select-income-type',
  selectVerificationMethod: '/select-verification-method',
  documents: '/documents',
  confirmExit: '/confirm-exit',
  employerNotFound: '/employer-not-found',
  feedback: '/feedback',
  fakeWaitingForInstant: '/fake-waiting-for-instant',
  exit: '/exit',
  error: '/error',
  unauthorized: '/unauthorized',
  feedbackComplete: '/feedback-complete',
  platformCheck: '/platform-check',
  taxLink: '/tax-link',
  platformSearch: '/platform-search',
  confirmEmployer: '/confirm-employer',
  connectionError: '/connection-error',
  bankStatedInformation: '/bank-stated-information',
  finicityConnect: '/bank-connect-finicity',
  bankIdentifyIncome: '/bank-identify-income',
  bankConnectedTasks: '/bank-connected-tasks',

  // Orchestration Engine
  oe: '/oe',

  // Docs V2 routes
  alternativeMethods: '/alternative-methods',
  selectDocumentType: '/select-document-type',
  selectOtherDocumentType: '/select-other-document-type',
  uploadDocuments: '/upload-documents',
}

// These routes should *not* be used for navigation. They are used for internal routing logic. If you want to navigate
// to any of these routes, call navigate(routes.root) instead, which will redirect to the appropriate screen.
export const internalRoutes = {
  sessionStateInitialized: '/session-state/initialized',
  sessionStateWaitingForInstantData: '/session-state/waiting-for-instant-data',
  sessionStateConsent: '/session-state/consent',
  sessionStateDirectTasks: '/session-state/tasks',
  sessionStateTerminalComplete: '/session-state/terminal-complete',
  sessionStateTerminalCompleteByOtherStrategy: '/session-state/terminal-complete-by-other-strategy',
  sessionStateTerminalExpired: '/session-state/terminal-expired',
  sessionStateTerminalFallback: '/session-state/terminal-fallback',
  sessionStateTerminalFailed: '/session-state/terminal-failed',
}

export const sessionStateRoutes: Record<ClientSessionState, string> = {
  [ClientSessionState.INITIALIZED]: internalRoutes.sessionStateInitialized,
  [ClientSessionState.WAITING_FOR_INSTANT_DATA]: internalRoutes.sessionStateWaitingForInstantData,
  [ClientSessionState.CONSENT]: internalRoutes.sessionStateConsent,
  [ClientSessionState.EMPLOYMENTS]: internalRoutes.sessionStateDirectTasks,
  [ClientSessionState.TERMINAL_COMPLETE]: internalRoutes.sessionStateTerminalComplete,
  [ClientSessionState.TERMINAL_COMPLETE_BY_OTHER_STRATEGY]: internalRoutes.sessionStateTerminalCompleteByOtherStrategy,
  [ClientSessionState.TERMINAL_EXPIRED]: internalRoutes.sessionStateTerminalExpired,
  [ClientSessionState.TERMINAL_FALLBACK]: internalRoutes.sessionStateTerminalFallback,
  [ClientSessionState.TERMINAL_FAILED]: internalRoutes.sessionStateTerminalFailed,
}
